import React from 'react'

const Platform = () => {
  return (
    <div>
      
    </div>
  )
}

export default Platform
